import { useState, useEffect } from 'react'
import axios, { AxiosResponse, AxiosError } from 'axios'

import { useRecoilState, useRecoilValue } from 'recoil'
import { playQueueState } from '../../../../../src/atoms/PlayQueueAtom'
import { walletState } from '../../../../../src/atoms/WalletAtom'

import Slick from 'react-slick'
import 'slick-carousel/slick/slick.css'
import 'slick-carousel/slick/slick-theme.css'

import MusicCard from './card'

type NFT = {
  chain_id: number
  chain_name: string
  contract_address: string
  token_id: string
  name: string
  image: string
  trial_sound: string
  sound: string
  artist_name: string
  artist_public_id: string
  genres: Genre[]
}

function HomePickupMusics() {
  const [pickupNfts, setPickupNfts] = useState<NFT[]>([])

  // レコメンドエンジンを使用可能な状態かどうか
  const [isRecommendable, setIsRecommendable] = useState<boolean>(false)

  // レコメンドエンジンを使用した結果を渡されたかどうか
  const [useRecommend, setUseRecommend] = useState<boolean>(false)

  const [, setPlayList] = useRecoilState(playQueueState)
  const walletAddress = useRecoilValue(walletState)

  useEffect(() => {
    fetchPicupMusics('')
  }, [])

  useEffect(() => {
    if (walletAddress) fetchPicupMusics(walletAddress)
  }, [walletAddress])

  const fetchPicupMusics = (wa: string) => {
    axios({
      method: 'GET',
      url: `${import.meta.env.VITE_API_BASE_URI}/api/v1/home/pickup_musics`,
      params: {
        wallet_address: wa,
      },
    })
      .then(
        (
          response: AxiosResponse<{
            nfts: NFT[]
            use_recommend: boolean
            is_recommendable: boolean
          }>
        ) => {
          setPickupNfts(response.data.nfts)
          setIsRecommendable(response.data.is_recommendable)
          setUseRecommend(response.data.use_recommend)
        }
      )
      .catch((error: AxiosError<{ error: string }>) => {
        console.error('error', error)
      })
  }

  const playMusic = (target: {
    chain_id: number
    contract_address: string
    token_id: string
  }) => {
    // targetのchain_id,contract_address,token_idを持つNFTをpickupNftsから探す
    const targetNft = pickupNfts.find(
      (nft) =>
        nft.chain_id === target.chain_id &&
        nft.contract_address === target.contract_address &&
        nft.token_id === target.token_id
    )
    if (targetNft === undefined) return

    // targetNft以降のNFTをplayListに追加する
    const playList = pickupNfts.slice(pickupNfts.indexOf(targetNft))

    // targetNft以前のNFTをplayListに追加する
    const beforePlayList = pickupNfts.slice(0, pickupNfts.indexOf(targetNft))

    // playListとbeforePlayListを結合する
    const newPlayList = playList.concat(beforePlayList)

    setPlayList(
      newPlayList.map((nft) => {
        return {
          chain_id: nft.chain_id,
          contract_address: nft.contract_address,
          token_id: nft.token_id,
          name: nft.name,
          image: nft.image,
          sound: nft.trial_sound,
          artist_name: nft.artist_name,
          artist_public_id: nft.artist_public_id,
        }
      })
    )
  }

  const postRecommendResult = () => {
    if (!walletAddress || !isRecommendable) return
    axios({
      method: 'POST',
      url: `${import.meta.env.VITE_API_BASE_URI}/api/v1/home/recommend_result`,
      params: {
        wallet_address: walletAddress,
        use_recommend: useRecommend,
      },
    })
      .then((response: AxiosResponse<{ message: string }>) => {
        // console.log(response.data.message)
      })
      .catch((error: AxiosError<{ error: string }>) => {
        console.error('error', error)
      })
  }

  const settings = {
    autoplay: true,
    autoplaySpeed: 5000,
    dots: true,
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 3,
    centerMode: true,
    centerPadding: '0',
    swipeToSlide: true,
    arrows: false,
  }

  const musicContents = (
    <div className="musics">
      <Slick {...settings}>
        {pickupNfts.map((nft, index) => (
          <MusicCard
            key={index}
            nft={nft}
            playMusic={playMusic}
            postRecommendResult={postRecommendResult}
          />
        ))}
      </Slick>
    </div>
  )

  return <section className="pickup-musics">{musicContents}</section>
}

export default HomePickupMusics
